// extracted by mini-css-extract-plugin
module.exports = {"page":"bk-z","cartModal":"ck-z","checkout":"dk-z","placeholder":"ek-z","account":"fk-z"};